exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebarLogoFade-enter-active[data-v-f81b12d0]{-webkit-transition:opacity 1.5s;transition:opacity 1.5s}.sidebarLogoFade-enter[data-v-f81b12d0],.sidebarLogoFade-leave-to[data-v-f81b12d0]{opacity:0}.sidebar-logo-container[data-v-f81b12d0]{position:relative;width:100%;height:60px;line-height:60px;background:#031e39;text-align:center;overflow:hidden}.sidebar-logo-container .sidebar-logo-link[data-v-f81b12d0]{height:100%;width:100%}.sidebar-logo-container .sidebar-logo-link .sidebar-logo[data-v-f81b12d0]{height:100%;width:100%}", ""]);

// exports
